export default __webpack_public_path__ + "images/models/b183eda12112bfa1cf992212599d8606.usdz";